import { Component, OnInit, inject, output, input, linkedSignal } from '@angular/core';
import { PanoptycDataService } from '../../../service/panoptyc-data.service';
import { UserLoginService } from '../../../service/user-login.service';
import { Router } from '@angular/router';
import { CancellationComment, ReportMode, WalkoutComment } from '../../../types';
import { hasStatus } from '../../../error.utils';

@Component({
  selector: 'app-transaction-comments',
  templateUrl: './transaction-comments.component.html',
  styleUrls: ['./transaction-comments.component.scss'],
  standalone: false,
})
export class TransactionCommentsComponent implements OnInit {
  userService = inject(UserLoginService);
  router = inject(Router);
  private dataService = inject(PanoptycDataService);

  readonly cancellationId = input<string | undefined>(undefined);
  public comments = input<WalkoutComment[] | CancellationComment[]>([]);
  public commentsInternal = linkedSignal(() => this.comments());
  readonly mode = input<ReportMode | undefined>(undefined);

  readonly newComment = output<{ newComment: boolean }>();

  handleDataForbidden(error: unknown) {
    if (hasStatus(error) && error.status === 403) {
      try {
        this.router.navigate(['/403']);
      } catch (e) {
        console.error(e);
      }
    }
  }

  ngOnInit() {
    if (!this.comments()) {
      this.loadComments();
    }
  }

  loadComments() {
    this.dataService.getTransactionComments(this.cancellationId()).subscribe(
      (data) => {
        this.commentsInternal.set(data);
      },
      (error) => {
        this.handleDataForbidden(error);
      },
    );
  }

  handleCommentSubmitStart() {}

  handleCommentSubmitEnd() {
    this.loadComments();
    this.newComment.emit({ newComment: true });
  }
}
